import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FireIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M-.06.07h24v24h-24Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.94,15.07c0-5.44-7-7-7-13C8,4.52,10.35,9.61,10.35,11.36a1.34,1.34,0,0,1-2.68,0,9.25,9.25,0,0,1,.38-2.76,8.79,8.79,0,0,0-3.11,6.48,7,7,0,0,0,14,0Z"
  })]
}), 'FireIcon');